import React from 'react';
import { Button, VStack } from '@chakra-ui/react';

export default function MenuPreview() {
  const handleOpenClientMenu = () => {
    window.open('/menu?anonymousPreview=1', '_blank', 'noopener,noreferrer');
  };

  return (
    <VStack w='100%' align='stretch'>
      <Button onClick={handleOpenClientMenu}>Apri menù cliente</Button>
    </VStack>
  );
}

